import React from 'react';
import { X, MapPin, QrCode } from 'lucide-react';

interface PortalGuruModalMetodePresensiProps {
    onSelect: (method: 'gps' | 'qr') => void;
    onClose: () => void;
}

export const PortalGuruModalMetodePresensi: React.FC<PortalGuruModalMetodePresensiProps> = ({ onSelect, onClose }) => {
    return (
        <div className="fixed inset-0 z-[100] flex items-end justify-center sm:items-center px-4 pb-6 sm:p-0">
            <div className="absolute inset-0 bg-gray-900/60 backdrop-blur-sm transition-opacity" onClick={onClose}></div>
            <div className="relative w-full max-w-sm bg-white rounded-3xl p-6 shadow-2xl ring-1 ring-white/10 transform transition-all animate-in slide-in-from-bottom-10 fade-in duration-300">
                <div className="absolute top-4 right-4 z-10">
                    <button onClick={onClose} className="p-1.5 rounded-full text-gray-400 hover:bg-gray-100 transition-colors">
                        <X size={20} />
                    </button>
                </div>

                <div className="text-center mb-6 mt-2">
                    <h3 className="text-xl font-bold text-[#111813] tracking-tight">Metode Presensi</h3>
                    <p className="text-xs text-[#63886f] mt-1.5">Pilih cara Anda melakukan presensi</p>
                </div>

                <div className="flex flex-col gap-4">
                    <button
                        onClick={() => onSelect('gps')}
                        className="flex flex-col items-center justify-center gap-3 p-5 rounded-2xl border-2 border-transparent bg-blue-50 hover:bg-blue-100 hover:border-blue-200 transition-all group"
                    >
                        <div className="size-14 rounded-full bg-blue-500 flex items-center justify-center text-white shadow-lg shadow-blue-500/30 group-hover:scale-110 transition-transform">
                            <MapPin size={28} />
                        </div>
                        <div className="text-center">
                            <span className="block text-sm font-bold text-blue-900">Gunakan GPS</span>
                            <span className="block text-[11px] text-blue-700/80 mt-1">Deteksi lokasi otomatis via satelit</span>
                        </div>
                    </button>

                    <div className="relative flex items-center py-2">
                        <div className="flex-grow border-t border-gray-100"></div>
                        <span className="flex-shrink-0 mx-4 text-gray-400 text-xs font-medium">ATAU</span>
                        <div className="flex-grow border-t border-gray-100"></div>
                    </div>

                    <button
                        onClick={() => onSelect('qr')}
                        className="flex flex-col items-center justify-center gap-3 p-5 rounded-2xl border-2 border-transparent bg-emerald-50 hover:bg-emerald-100 hover:border-emerald-200 transition-all group"
                    >
                        <div className="size-14 rounded-full bg-emerald-500 flex items-center justify-center text-white shadow-lg shadow-emerald-500/30 group-hover:scale-110 transition-transform">
                            <QrCode size={28} />
                        </div>
                        <div className="text-center">
                            <span className="block text-sm font-bold text-emerald-900">Scan QR Code</span>
                            <span className="block text-[11px] text-emerald-700/80 mt-1">Arahkan kamera ke QR di lokasi</span>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    );
};
